module.exports = __webpack_public_path__ + "img/we-char.8eeb0374.svg";